import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { API, fmtErr } from "../lib/api";

export default function Impersonate() {
  const { token } = useParams();
  const [error, setError] = useState("");

  useEffect(() => {
    API.post("/auth/impersonate", { token })
      .then(() => {
        window.location.href = "/dashboard";
      })
      .catch((e) => setError(fmtErr(e)));
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background" data-testid="impersonate-page">
      <div className="w-full max-w-sm rounded-lg border bg-card p-8 text-center">
        {error ? (
          <>
            <p className="text-sm font-medium text-destructive" data-testid="impersonate-error">{error}</p>
            <Link to="/admin" className="mt-4 inline-block text-sm font-medium text-primary hover:underline">Back to Admin Portal</Link>
          </>
        ) : (
          <p className="text-sm text-muted-foreground" data-testid="impersonate-loading">Entering account…</p>
        )}
      </div>
    </div>
  );
}
